import data from "../../../../../packages/react/src/Dialog/Dialog.docs.json";
import State from "../../../../components/State";
import * as React from 'react';
export default {
  data,
  State,
  React
};